import { SVGProps } from "react";

export default function PresentationBoardIcon(props: SVGProps<SVGSVGElement>) {
  const { width = 20, height = 20, stroke = "currentColor", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M17.5 8.33366V1.66699H2.5V11.7503C2.5 12.342 2.61668 12.8336 2.85001 13.217C3.23334 13.8503 3.93334 14.1753 4.925 14.1753H15.0833C16.6667 14.1753 17.5 13.342 17.5 11.7586"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66406 1.66699H18.3307"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66406 18.3337L9.9974 16.667V14.167"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 18.3337L10 16.667"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 9.16699L8.87499 6.97532C9.08333 6.80032 9.35833 6.85033 9.49999 7.08366L10.5 8.75033C10.6417 8.98366 10.9167 9.02533 11.125 8.85866L13.75 6.66699"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
